import * as Pages from './pages/index';

const urlParams = new URLSearchParams(window.location.search);

const pagesObject = {
  '/': Pages.Pagina1,
};

const quantidadePaginas = Object.keys(Pages).length;

for (let i = 1; i <= quantidadePaginas; i++) {
  const pagina = `Pagina${i}`;
  pagesObject[`/${i}`] = Pages[pagina];
}

const routes = !urlParams.has('routemap') ? pagesObject : new Map();

if (urlParams.has('routemap')) {
  routes.set('/', Pages.Pagina1);
  for (let i = 1; i <= quantidadePaginas; i++) {
    const pagina = `Pagina${i}`;
    routes.set(`/${i}`, Pages[pagina]);
  }
}

export default routes;
